import { redirect } from 'react-router';

import { LoginResponse } from 'shared/api/__generated__';

export function hideIfAdminMO() {
  const userData = localStorage.getItem('USER_DATA');

  const user: LoginResponse = JSON.parse(userData ?? '{}');

  if (user.role?.key === 'admin.mo') return redirect(`/manage/no-access`);

  return null;
}
